import WelcomeText from "./WelcomeText";
import DashboardElements from "./DashboardElements";
import StatsContainer from "./StatsContainer";
import MiddleContainer from "./MiddleContainer";
import BottomContainer from "./BottomContainer";
import { GActions, useGlobalContext } from "../../contexts/GlobalContext";
import { getLeads } from "../../queries/conv";
import {
    getAllMentorsPerformance,
    getMentorsByGroup,
} from "../../queries/mentor";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { BASE_URL } from "../../queries/url";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Done } from "@material-ui/icons";
import axios from "axios";
import { get_program_label } from "../EmailDashboard/programData";

const DashboardContainer = () => {
    const [state, globalDispatch] = useGlobalContext();

    const [leadsDataExcel, setLeadsDataExcel] = useState();
    const [downloading, setDownloading] = useState("nope");

    const user = state.user;

    // Filter leads by program access
    const filterLeadsByPrograms = (leads) => {
        const { userProgramAccess, user } = state;

        // Super admin sees everything
        if (user?.privilege === "admin") return leads;

        // University admin sees all programs
        if (!userProgramAccess ||
            userProgramAccess.role === "university_admin" ||
            !userProgramAccess.assignedPrograms?.length) {
            return leads;
        }

        // Debug: Log programs in leads table data
        const uniquePrograms = [...new Set(leads.map(lead => lead.program))];
        // console.log("TABLE - Available programs in data:", uniquePrograms);
        // console.log("TABLE - User's assigned programs:", userProgramAccess.assignedPrograms);
        // console.log(leads)
        // Program user sees only assigned programs
        const filtered = leads.filter(lead =>
            userProgramAccess.assignedPrograms.includes(lead.program)
        );

        // console.log("TABLE - Filtered lead count:", filtered.length, "out of", leads.length);
        return filtered;
    };
    const dpFetchMentors = async () => {
        if (!state.mentors) {
            globalDispatch({
                type: GActions.SET_MENTORS_LOADING,
                payload: true,
            });
            const result = await getMentorsByGroup();
            globalDispatch({
                type: GActions.SET_MENTORS,
                payload: result.mentors,
            });
            globalDispatch({
                type: GActions.SET_MENTORS_LOADING,
                payload: false,
            });
            if (!result.ok) {
                globalDispatch({
                    type: GActions.SET_SNACKBAR,
                    payload: {
                        open: true,
                        message: result.message,
                        severity: "error",
                    },
                });
            }
        }
    };

    const dpFetchConversations = async () => {
        if (!state.conversations) {
            globalDispatch({
                type: GActions.SET_CONVERSATION_LOADING,
                payload: true,
            });
            const resultTEST = await getAllMentorsPerformance(
                state.user?.privilege
            );
            const result = await getLeads();
            const leads = result.leads;

            if (state.user?.privilege === "boston") {
                const leadDataUniversity = leads.map((lead) => ({
                    // Name: lead.name,
                    "First Name": lead.firstname,
                    "Last Name": lead.lastname,
                    Email: lead.email,
                    Cycle: lead.year,
                    Program: get_program_label(lead.program, state.user?.privilege),
                    Country: lead.country,
                    Mentor: lead.mentorName,
                    "Last Response Mentor": lead.lastResponseMentor,
                    "Last Response Student": lead.lastResponseStudent,
                    "Created On": new Date(lead.createdAt),
                }));
                setLeadsDataExcel(leadDataUniversity);
            } else {
                const leadDataUniversity = leads.map((lead) => ({
                    Name: lead.name,
                    Email: lead.email,
                    Cycle: lead.year,
                    Mentor: lead.mentorName,
                    "Last Response Mentor": lead.lastResponseMentor,
                    "Last Response Student": lead.lastResponseStudent,
                    "Created On": new Date(lead.createdAt),
                }));
                setLeadsDataExcel(leadDataUniversity);
            }
            globalDispatch({
                type: GActions.SET_ALL_MENTOR_PERFORMANCE,
                payload: resultTEST.mentorPerformances,
            });

            // Filter leads by program access before setting
            const filteredLeads = filterLeadsByPrograms(leads);

            globalDispatch({
                type: GActions.SET_CONVERSATIONS,
                payload: filteredLeads,
            });
            globalDispatch({
                type: GActions.SET_CONVERSATION_LOADING,
                payload: false,
            });
            if (!result.ok) {
                globalDispatch({
                    type: GActions.SET_SNACKBAR,
                    payload: {
                        open: true,
                        message: result.message,
                        severity: "error",
                    },
                });
            }
        }
    };
    const fetchOverviewData = async () => {
        await dpFetchMentors();
        if (
            state.user?.privilege !== "Fisher" &&
            state.user?.privilege !== "PACE"
        ) {
            // await fetchGroups();
            await dpFetchConversations();
        }
    };

    const handleExportLeads = async () => {
        try {
            setDownloading("yep");

            const loginAxios = axios.create({
                withCredentials: true,
                baseURL: BASE_URL,
            });

            const result = await loginAxios.get("/dashboard/summary");
            console.log("EXPORT - Response type:", typeof result.data);
            console.log("EXPORT - Is array?", Array.isArray(result.data));

            let allLeads = [];

            // Check if data is already an array of objects (not CSV string)
            if (Array.isArray(result.data)) {
                allLeads = result.data;
                console.log("EXPORT - Sample lead:", allLeads[0]);
            } else if (typeof result.data === 'string') {
                // Parse CSV data
                const csvLines = result.data.trim().split('\n');
                console.log("EXPORT - CSV lines count:", csvLines.length);
                console.log("EXPORT - CSV header:", csvLines[0]);

                allLeads = csvLines.slice(1).map(line => { // Skip header row
                    const fields = [];
                    let current = '';
                    let inQuotes = false;

                    for (let i = 0; i < line.length; i++) {
                        const char = line[i];
                        if (char === '"') {
                            inQuotes = !inQuotes;
                        } else if (char === ',' && !inQuotes) {
                            fields.push(current);
                            current = '';
                        } else {
                            current += char;
                        }
                    }
                    fields.push(current);

                    return {
                        firstName: fields[0]?.replace(/"/g, '') || '',
                        lastName: fields[1]?.replace(/"/g, '') || '',
                        email: fields[2]?.replace(/"/g, '') || '',
                        phone: fields[3]?.replace(/"/g, '') || '',
                        country: fields[4]?.replace(/"/g, '') || '',
                        program: fields[5]?.replace(/"/g, '') || '',
                        year: fields[6]?.replace(/"/g, '') || '',
                        type: fields[7]?.replace(/"/g, '') || '',
                        createdAt: fields[8]?.replace(/"/g, '') || ''
                    };
                }).filter(lead => lead.email); // Filter out empty rows
            }

            if (allLeads.length === 0) {
                console.error("EXPORT - No data received from /dashboard/summary");
                alert("No data available to export. Please wait for leads to load.");
                setDownloading("nope");
                return;
            }

            console.log("EXPORT - Total leads fetched:", allLeads.length);

            // Apply program filtering
            let leadsToExport = allLeads;
            if (state.userProgramAccess?.role === "program_user" &&
                state.userProgramAccess?.assignedPrograms?.length > 0) {

                const uniquePrograms = [...new Set(allLeads.map(lead => lead.program))].filter(p => p);
                console.log("EXPORT - Available programs:", uniquePrograms);
                console.log("EXPORT - User's assigned programs:", state.userProgramAccess.assignedPrograms);

                leadsToExport = allLeads.filter(lead =>
                    state.userProgramAccess.assignedPrograms.includes(lead.program)
                );
                console.log("EXPORT - Filtered", leadsToExport.length, "leads out of", allLeads.length);

                if (leadsToExport.length === 0) {
                    alert("No leads found for your assigned programs.");
                    setDownloading("nope");
                    return;
                }
            }

            // Convert to CSV
            if (leadsToExport.length > 0) {
                // Convert program values to labels before exporting
                const userUniversity = state.user?.privilege;
                console.log("EXPORT - Using university from user privilege:", userUniversity);
                console.log("EXPORT - Sample lead before conversion:", leadsToExport[0]);

                const leadsWithLabels = leadsToExport.map(lead => {
                    const programLabel = get_program_label(lead.program, userUniversity);
                    return {
                        ...lead,
                        program: programLabel
                    };
                });
                console.log("EXPORT - Sample lead after conversion:", leadsWithLabels[0]);

                const headers = Object.keys(leadsWithLabels[0]).join(',');
                const rows = leadsWithLabels.map(lead =>
                    Object.values(lead).map(val =>
                        typeof val === 'string' && val.includes(',') ? `"${val}"` : val
                    ).join(',')
                );
                const csv = [headers, ...rows].join('\n');

                // Trigger download
                const blob = new Blob([csv], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'leads_export.csv';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }

            setTimeout(() => {
                setDownloading("done");
                setTimeout(() => setDownloading("nope"), 2000);
            }, 500);
        } catch (error) {
            console.error("Error exporting leads:", error);
            setDownloading("nope");
        }
    };

    useEffect(() => {
        fetchOverviewData();
    }, []);
    return (
        <>
            <DashboardElements.DasboardContainer>
                <div className="flex justify-between">
                    <WelcomeText />
                    <div
                        className="mr-4 cursor-pointer"
                        onClick={handleExportLeads}
                    >
                        <button className="bg-green-600 hover:bg-green-700 active:scale-95 text-white text-base font-[Inter] font-semibold px-3 py-1 rounded-md flex items-center justify-center gap-2">
                            Export All Leads{" "}
                            {downloading === "yep" && (
                                <CircularProgress size={18} color="inherit" />
                            )}
                            {downloading === "nope" && (
                                <FileDownloadIcon
                                    sx={{
                                        fontSize: "17px",
                                    }}
                                />
                            )}
                            {downloading === "done" && (
                                <Done
                                    sx={{
                                        fontSize: "17px",
                                    }}
                                />
                            )}
                        </button>
                    </div>
                </div>
                <StatsContainer />
                <MiddleContainer />
                <BottomContainer leadsDataExcel={leadsDataExcel} />
            </DashboardElements.DasboardContainer>
        </>
    );
};

export default DashboardContainer;
